import { useEffect, useState } from "react";
import { Rocket, Lock, CheckCircle2 } from "lucide-react";

function diff(target) {
  const ms = Math.max(0, new Date(target).getTime() - Date.now());
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  return { days, hours, minutes, seconds };
}

// Branded early-access screen with a live countdown to the launch date.
export function EarlyAccess({ product = "the service", launchDate = "2026-11-07T00:00:00+00:00" }) {
  const [t, setT] = useState(() => diff(launchDate));
  useEffect(() => {
    const id = setInterval(() => setT(diff(launchDate)), 1000);
    return () => clearInterval(id);
  }, [launchDate]);

  const units = [
    { label: "Days", value: t.days },
    { label: "Hours", value: t.hours },
    { label: "Minutes", value: t.minutes },
    { label: "Seconds", value: t.seconds },
  ];

  return (
    <div className="max-w-2xl" data-testid="early-access">
      <div className="inline-flex items-center gap-2 rounded-full border border-green-400/30 bg-green-400/5 px-3 py-1 mb-6">
        <CheckCircle2 size={14} className="text-green-400" />
        <span className="text-xs uppercase tracking-widest text-green-400">Your account is ready</span>
      </div>

      <h2 className="font-display text-3xl sm:text-4xl tracking-tighter text-paper flex items-center gap-3">
        <Rocket size={28} className="text-paper" strokeWidth={1.5} /> Early access
      </h2>
      <p className="mt-4 text-base text-fog leading-relaxed">
        Thanks for signing up. <span className="text-paper">{product}</span> opens on{" "}
        <span className="text-paper">November 7, 2026</span>. We'll email you the moment it goes live —
        no further action needed.
      </p>

      <div className="mt-8 grid grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden" data-testid="early-access-countdown">
        {units.map((u) => (
          <div key={u.label} className="bg-surface p-5 text-center">
            <div className="font-display text-3xl sm:text-4xl tracking-tighter text-paper tabular-nums">
              {String(u.value).padStart(2, "0")}
            </div>
            <div className="mt-1 text-[10px] uppercase tracking-widest text-fog">{u.label}</div>
          </div>
        ))}
      </div>

      <p className="mt-6 text-xs text-fog flex items-center gap-2">
        <Lock size={13} /> Access is reserved to your registered account and unlocks automatically at launch.
      </p>
    </div>
  );
}
